import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

export const SpinnerWrapper = styled.div`
  grid-area: spinner;
  justify-self: center;
  justify-content: center;
  display: flex;
`;

export const Spinner = styled.div`
  width: 25px;
  height: 25px;
  border: ${themeGet('colors.pc-red', '#E1251B')} solid 4px;
  border-right-color: transparent;
  border-radius: 50%;
  animation: rotate-cw;
  animation-duration: 1s;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
  @keyframes rotate-cw {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;
